<template>
    <div class="close-chat-message">
        <hr />
        <div>👏 De chat is beëindigd</div>
        <hr />
    </div>
</template>

<style scoped lang="scss">
    .close-chat-message {
        display: grid;
        grid-template-columns: auto max-content auto;
        color: #8c8c8c;
        align-items: center;
        gap: 1rem;
        margin: 2rem 0 1rem 0;
        font-size: 0.9rem;

        hr {
            width: 100%;
            height: 1px;
            background-color: #dadada;
            border: none;
            margin: 0;
        }
    }
</style>
